module.exports = require('./dist/pages/_app')
